import {
  CreditCardFormAdd,
  CreditCardFormAddModal,
  CreditCardFormEdit,
  CreditCardFormEditModal,
} from './components';

export const CreditCardForm = {
  Add: CreditCardFormAdd,
  AddModal: CreditCardFormAddModal,
  Edit: CreditCardFormEdit,
  EditModal: CreditCardFormEditModal,
};
